var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn my-1 d-flex align-items-center justify-content-center small-button",attrs:{"type":"button"}},[_vm._t("default"),_vm._v(_vm._s(_vm.title)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }